export const Services = {
   "GraphicsNextToArrive": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "POST",
      "descrp": "data of graphics"
   },
   "ContainerNextToArrive": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "GET",
      "descrp": "Get data containers"
   },
   "ContainerNextToArriveId": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "GET",
      "descrp": "Get data for id of container"
   },
   "GraphicsArrived": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "POST",
      "descrp": "data graphics arrive module"
   },
   "ContainersArrived": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "GET",
      "descrp": "get data container arrive module"
   },
   "UpdateContainers": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "PUT",
      "descrp": "Update container information"
   },
   "CreateIncidencia": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "POST",
      "descrp": "create an incident"
   },
   "UpdateIncidencia": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "PUT",
      "descrp": "create an incident"
   },
   "DeleteIncidencia": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "POST",
      "descrp": "create an incident"
   },
   "EventsContainer": {
      "path": "https://rrapievents.azurewebsites.net/",
      "method": "GET",
      "descrp": "Get data events containers"
   },
   "Documents": {
      "path": "https://rrapidocuments.azurewebsites.net/",
      "method": "GET",
      "descrp": "Get documents"
   },
   "Catalogos": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "GET",
      "descrp": "create an incident"
   },
   "Getcomments": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "GET",
      "descrp": "get data comments"
   },
   "createComments": {
      "path": "https://rrapicontainers.azurewebsites.net/",
      "method": "POST",
      "descrp": "create a comment"
   },
   "generate_xls": {
      "path": "https://servicereportapi.azurewebsites.net/report/dynamic/xlsx",
      "method": "",
      "descrp": "Dowload xls"
   }
}